import { Close } from '@mui/icons-material'
import Icon from './icons/index'
import React from 'react'
import { useAppServices } from '../hook/services'
import { useUserInfo } from '../context/user'
import toast from 'react-hot-toast'


const styles = {
    INFORMATION: {
        icon: 'information_circle',
        bg: "#F7F6FF",
        border: "1px solid #3647FF",
    },
    ANNOUNCEMENT: {
        icon: 'success_tick',
        bg: "#E7FFE9",
        border: "1px solid #009951",
    },
    WARNING: {
        icon: 'warning',
        bg: "#FFF1D4",
        border: "1px solid #BF6A02",
    },
    ERROR: {
        icon: 'error_cross',
        bg: "#FFF0F0",
        border: "1px solid #C00F0C",
    }
}

const ToastNotificationBanner = ({ agency, user }) => {
    const service = useAppServices()
    const saveActiveLocation = useUserInfo()[1]
    const onCloseNotification = async (id) => {
        const payload = {
            _id: user._id,
            closed_notifications: [...(user?.closed_notifications || []), id]
        }
        const { response, error } = await service.users.updateUser({ payload })
        if (response?.success) {
            await saveActiveLocation(response?.data)
        }
        else {
            toast.error(error?.message || "Failed to close notification")
        }
    }

    return (
        <div style={{ position: "fixed", top: "90px", right: "20px", zIndex: "99999", display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
            {agency?.notifications?.filter(item => item.status && (item.endDate === null || new Date(item.endDate) >= new Date()) && !user?.closed_notifications?.includes(item.id))?.map((notification, index) => {
                const style = styles[notification.category] || styles.INFORMATION
                return (
                    <div key={index} style={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: style.bg,
                        border: style.border,
                        borderRadius: "8px",
                        padding: "10px 15px",
                        marginBottom: "10px",
                        width: notification?.cta_link ? "416px" : "317px",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        position: "relative",
                        justifyContent: "space-between",

                    }}>

                        <button style={{ position: "absolute", top: "0px", right: "10px" }} onClick={() => onCloseNotification(notification.id)}><Close sx={{ color: "#c5c5c5ff", fontSize: "16px" }} /></button>
                        <div style={{ display: "flex", alignItems: "start" }}>
                            <div className="mr-2" style={{ marginTop: "3px" }}>
                                <Icon id={style.icon} />
                            </div>
                            <div className="text-sm font-medium text-gray-700">
                                <p style={{ marginBottom: "0px", fontSize: "14px", fontWeight: "600", fontFamily: "Inter" }}>{notification.title}</p>
                                <p style={{ marginBottom: "0px", fontSize: "12px", fontWeight: "400", fontFamily: "Inter" }}>{notification.message}</p>
                            </div>
                        </div>
                        <div>
                            {notification?.cta_link && (<>
                                <button onClick={() => {
                                    const isInternal = notification.cta_link?.startsWith('/');
                                    const url = isInternal || notification.cta_link?.includes('http')
                                        ? notification.cta_link
                                        : `https://${notification.cta_link}`;

                                    if (notification.linkOption === "SameWindow") {
                                        window.location.href = url;
                                    } else {
                                        window.open(url, "_blank", "noopener,noreferrer");
                                    }
                                }} style={{ textDecoration: "none", fontSize: "12px", fontWeight: "500", fontFamily: "Inter", border: "1px solid #d9d9d9", background: "#fff", color: "#000", borderRadius: "6px", padding: "5px 10px", marginRight: "20px" }}>
                                    {notification.cta_text}
                                </button>
                            </>)}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default ToastNotificationBanner